/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Sentry initialization for browser
 */

import type { Envelope, EnvelopeItemType, Event } from '@sentry/types'
import { isThirdPartyException } from './isThirdPartyException'

// This is not exported by the SDK so have to re-define here
interface MatchParam {
  /** The envelope to be sent */
  envelope: Envelope
  /**
   * A function that returns an event from the envelope if one exists. You can optionally pass an array of envelope item
   * types to filter by - only envelopes matching the given types will be returned.
   *
   * @param types Defaults to ['event'] (only error events will be returned)
   */
  getEvent(types?: EnvelopeItemType[]): Event | undefined
}

export const dsnFromEvent =
  (dsn: string, thirdPartyDsn: string, release: string) =>
  ({ getEvent }: MatchParam) => {
    const event = getEvent(['event'])
    const exceptionValues = event?.exception?.values
    if (exceptionValues && isThirdPartyException(exceptionValues)) {
      return [{ dsn: thirdPartyDsn, release }]
    }
    return [{ dsn, release }]
  }
